import React from "react";
import { Card } from "react-rainbow-components";
import styled from "styled-components";
import Bag from "../../assets/icons/BugSale";
import Database from "../../assets/icons/Database";
import DatabaseUserPage from "../DatabaseUserPage";
import DatabaseAdminPage from "../DatabaseAdminPage";
import ProductSettingPage from "../ProductSettingPage";
import Coupon from "../../assets/icons/Coupon";
import CouponSettingPage from "../CouponSettingPage";
enum stateContent {
  databaseUser,
  databaseAdmin,
  promotion,
  coupon,
}
const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.5rem;
  height: 100vh;
  max-width: 100%;
  flex: 1;
`;

const GroupCard = styled.div`
  display: flex;
  justify-content: space-between;
  @media only screen and (max-width: 600px) {
    flex-direction: column;
  }
`;
const ContainerCard = styled.div`
  flex: 1;
  display: flex;
`;
const MyCard = styled(Card)`
  display: flex;
  flex: 1;
  margin: 0.5rem;

  &.group-card {
    align-items: center;
    justify-content: center;
    padding: 1rem;
    @media only screen and (max-width: 600px) {
      padding: 0.5rem;
    }
    cursor: pointer;

    & > svg {
      @media only screen and (max-width: 600px) {
        display: none;
      }
    }
    & > div {
      margin-left: 1rem;
      flex: 1;
      @media only screen and (max-width: 600px) {
        margin-left: 0;
      }
      & > h6 {
        @media only screen and (max-width: 600px) {
          margin: 0;
        }
      }
      & > p {
        @media only screen and (max-width: 600px) {
          display: none;
        }
        margin: 0;
        font-size: 0.75rem;
        &.right {
          text-align: right;
        }
      }
    }
  }
  &.content {
    overflow: scroll;
  }
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none; /* for Firefox */
  overflow-y: hidden;
  overflow-x: hidden;
`;

function SettingPage() {
  const [content, setContent] = React.useState<stateContent>(
    stateContent.promotion
  );
  return (
    <Container>
      <GroupCard className="group-card">
        <ContainerCard onClick={() => setContent(stateContent.promotion)}>
          <MyCard className="group-card">
            <Bag />
            <div>
              <h6>จัดการโปรโมชั่นสินค้า</h6>
              <p>ระบบจัดการสินค้า</p>
              <p>และโปรโมชัน</p>
            </div>
          </MyCard>
        </ContainerCard>
        <ContainerCard onClick={() => setContent(stateContent.coupon)}>
          <MyCard className="group-card">
            <Coupon />
            <div>
              <h6>จัดการคูปอง</h6>
              <p>เพิ่มคูปอง และ</p>
              <p>ผู้มีสิทธิ์ใช้คูปอง</p>
            </div>
          </MyCard>
        </ContainerCard>
        <ContainerCard onClick={() => setContent(stateContent.databaseAdmin)}>
          <MyCard className="group-card">
            <Database />
            <div>
              <h6>จัดการฐานข้อมูลผู้ดูแล</h6>
              <p>ข้อมูลผู้ดูแลระบบ</p>
              <p>หมอ, ฝ่ายขาย</p>
            </div>
          </MyCard>
        </ContainerCard>
        <ContainerCard onClick={() => setContent(stateContent.databaseUser)}>
          <MyCard className="group-card">
            <Database />
            <div>
              <h6>จัดการฐานข้อมูลลูกค้า</h6>
              <p>ข้อมูลลูกค้าในระบบ</p>
              <p>และสัตว์เลี้ยง</p>
            </div>
          </MyCard>
        </ContainerCard>
      </GroupCard>
      <MyCard className="content">
        {content === stateContent.promotion ? (
          <ProductSettingPage />
        ) : content === stateContent.databaseUser ? (
          <DatabaseUserPage />
        ) : content === stateContent.coupon ? (
          <CouponSettingPage />
        ) : (
          <DatabaseAdminPage />
        )}
      </MyCard>
    </Container>
  );
}

export default SettingPage;
